import axios from 'axios'
import config from '../config'

const deleteCouponApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}coupon`,
        method: "delete",
        data: params,
        headers: {
            "Content-Type": "application/json"
        }
    })

    return response

}

export default deleteCouponApi